import { render, staticRenderFns } from "./CarrierTaxFormModal.vue?vue&type=template&id=fba1e28a&scoped=true&"
import script from "./CarrierTaxFormModal.vue?vue&type=script&lang=js&"
export * from "./CarrierTaxFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba1e28a",
  null
  
)

export default component.exports